import { Box, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

type SuspenseSpinnerProps = {
  inline?: boolean;
};

const SuspenseSpinner = ({ inline = false }: SuspenseSpinnerProps) => {
  const { t } = useTranslation('common');

  return (
    <Box
      sx={inline
        ? {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: '100%',
        }
        : {
          position: 'fixed',
          left: 0,
          top: 0,
          width: '100%',
          height: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          display: 'flex',
        }}
    >
      <CircularProgress size={64} disableShrink thickness={3} aria-label={t('ACCESSIBILITY.LOADING')} />
    </Box>
  );
};

export default SuspenseSpinner;
